/* eslint-disable */
let ConvId

const BingPixel = {
  init(convId) {
    ConvId = convId
    try {
      ;(function (w, d, t, r, u) {
        var f, n, i
        ;(w[u] = w[u] || []),
          (f = function () {
            var o = { ti: convId }
            ;(o.q = w[u]), (w[u] = new UET(o)), w[u].push('pageLoad')
          }),
          (n = d.createElement(t)),
          (n.src = r),
          (n.async = 1),
          (n.onload = n.onreadystatechange =
            function () {
              var s = this.readyState
              ;(s && s !== 'loaded' && s !== 'complete') || (f(), (n.onload = n.onreadystatechange = null))
            }),
          (i = d.getElementsByTagName(t)[0]),
          i.parentNode.insertBefore(n, i)
      })(window, document, 'script', '//bat.bing.com/bat.js', 'uetq')
    } catch (e) {
      console.warn(e)
    }

    if (!ConvId) {
      return console.error('BingPixel.init(convId) missing conversion id.')
    }
  },

  pageView: () => {
    if (!ConvId) {
      return console.error('BingPixel init must be called first.')
    }

    window.uetq.push('pageLoad')
  },

  event: (name: string, data?: Record<string, unknown>) => {
    if (!ConvId) {
      return console.error('BingPixel init must be called first.')
    }
    window.uetq.push('event', name, data)
  },
}

export default BingPixel
